import React, { Suspense } from 'react';
import Loading from '@components/Loading';

const AsyncLoading = (props) => {
	const { component } = props;

	return <Suspense fallback={<Loading />}>{component}</Suspense>;
};

export default AsyncLoading;
